import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";

export default function PrivacyDataTable() {
  const rows = [
    {
      category: "Account & Contact Data",
      examples: "First and last name, email address, username, password.",
      purpose:
        "To create and manage your account, provide Services, and communicate with you.",
    },
    {
      category: "Payment Data",
      examples:
        "Credit/debit card number, billing address. (Processed by a third-party payment processor).",
      purpose: "To process payments for subscription services.",
    },
    {
      category: "Device & Usage Data",
      examples:
        "IP address, device ID, browser type, operating system, usage statistics, interaction with features.",
      purpose:
        "To provide and improve the Services, for security, and to identify usage trends.",
    },
    {
      category:
        "Sensitive Personal Information & Protected Health Information (PHI)",
      examples:
        "Health data you provide, responses to wellness surveys, usage of mental health exercises, information about physical or mental health conditions, race or ethnic origin.",
      purpose:
        "To personalize your wellness program, track your progress, and provide the core functionality of the Services. This is done only with your explicit consent.",
    },
    {
      category: "Employer-Provided Data",
      examples:
        "Your name and work email may be provided by your employer to confirm eligibility for our Services.",
      purpose:
        "To facilitate your enrollment in the employer-sponsored wellness program.",
    },
    {
      category: "User-Generated Content",
      examples:
        "Information you voluntarily provide in free-form fields, journal entries, or communications with us.",
      purpose:
        "To provide the features you use and to respond to your inquiries.",
    },
  ];

  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow sx={{ backgroundColor: "#f5f5f5" }}>
            <TableCell sx={{ fontWeight: "bold" }}>
              Category of Personal Data
            </TableCell>
            <TableCell sx={{ fontWeight: "bold" }}>Examples</TableCell>
            <TableCell sx={{ fontWeight: "bold" }}>
              Purpose(s) for Collection
            </TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {rows.map((row, index) => (
            <TableRow key={index}>
              <TableCell sx={{ verticalAlign: "top", width: "25%" }}>
                {row.category}
              </TableCell>

              <TableCell sx={{ verticalAlign: "top", width: "35%" }}>
                {row.examples}
              </TableCell>

              <TableCell sx={{ verticalAlign: "top", width: "40%" }}>
                {row.purpose}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
